import useReveal from "@/hooks/useReveal";

/**
 * Reveal — wraps children with the global scroll-reveal animation.
 * Variants: up | left | right | scale
 * delay: 0-8 (translates to .d-N class for staggered reveals)
 */
export default function Reveal({ children, variant = "up", delay = 0, className = "", as: Tag = "div" }) {
  const { ref, shown } = useReveal();
  const base =
    "r-init " +
    (variant === "up"
      ? "r-up"
      : variant === "left"
      ? "r-left"
      : variant === "right"
      ? "r-right"
      : "r-scale");
  const d = delay ? `d-${delay}` : "";
  return (
    <Tag ref={ref} className={`${base} ${d} ${shown ? "r-in" : ""} ${className}`}>
      {children}
    </Tag>
  );
}
